import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import API from '../../common/services/api.config.json';
import { ApiService } from '../../../modules/common/services/api.service';
import { RestResponse } from '../entities/rest.response.model';

@Injectable()

export class SmsService {

  constructor(
    public apiService: ApiService
  ) {

  }

  sendSMS(companyId: string): Observable<RestResponse> {
    let url = `${API.SMS.sendcompanysms}`;
    url = url.replace('{companyId}', companyId);
    return this.apiService.get(url);
  }

}
